import { defineStore } from 'pinia'
import { categoriesAPI } from '../services/api'

export const useCategoriesStore = defineStore('categories', {
  state: () => ({
    categories: [],
    loading: false,
    error: null
  }),

  getters: {
    categoriesByName: (state) => {
      return state.categories.reduce((acc, cat) => {
        acc[cat.name] = cat
        return acc
      }, {})
    },

    categoriesById: (state) => {
      return state.categories.reduce((acc, cat) => {
        acc[cat.id] = cat
        return acc
      }, {})
    }
  },

  actions: {
    async fetchCategories() {
      try {
        this.loading = true
        this.error = null

        const response = await categoriesAPI.getAll()
        this.categories = response.data.categories
      } catch (error) {
        this.error = error.response?.data?.error || 'Failed to fetch categories'
        throw error
      } finally {
        this.loading = false
      }
    },

    async syncCategories() {
      try {
        this.loading = true
        this.error = null

        await categoriesAPI.sync()
        await this.fetchCategories()
      } catch (error) {
        this.error = error.response?.data?.error || 'Failed to sync categories'
        throw error
      } finally {
        this.loading = false
      }
    }
  }
})
